module.exports = {
  title: 'Glassmorphism and Simplex Noise with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2023-03-29',
  slug: 'blur-circles',
  tags: ['skia'],
};
